export default __webpack_public_path__ + "static/media/Heebo-Medium.1ac328bf.ttf";